package dk.smark.chat

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import dk.smark.chat.ui.AddFriendScreen
import dk.smark.chat.ui.FriendsScreen
import dk.smark.chat.ui.HomeScreen
import dk.smark.chat.ui.LoginScreen
import dk.smark.chat.ui.ProfileScreen
import dk.smark.chat.ui.theme.AppTheme
import org.koin.compose.viewmodel.koinViewModel

@Composable
@Preview
fun App(startOnRegister: Boolean = false) {
    AppTheme {
        val viewModel: MainViewModel = koinViewModel()
        val currentUser by viewModel.currentUser.collectAsState()

        var isLoggedIn by remember { mutableStateOf(false) }
        var isCheckingCredentials by remember { mutableStateOf(true) }
        var showProfile by remember { mutableStateOf(false) }
        var showFriends by remember { mutableStateOf(false) }
        var showAddFriend by remember { mutableStateOf(false) }

        LaunchedEffect(Unit) {
            val saved = viewModel.getSavedCredentials()
            if (saved != null) {
                viewModel.login(
                    email = saved.email,
                    password = saved.password,
                    rememberMe = true,
                    onSuccess = { isLoggedIn = true },
                    onError = {
                        // Saved credentials are no longer valid — clear them
                        viewModel.clearSavedCredentials()
                    }
                )
            }
            isCheckingCredentials = false
        }

        when {
            isCheckingCredentials -> Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator()
            }

            isLoggedIn -> when {
                showAddFriend -> AddFriendScreen(
                    userId = currentUser?.id ?: 0,
                    inviterName = currentUser?.name ?: "",
                    onBack = { showAddFriend = false }
                )
                showFriends -> FriendsScreen(
                    userId = currentUser?.id ?: 0,
                    onAddFriend = { showAddFriend = true },
                    onBack = { showFriends = false }
                )
                showProfile -> ProfileScreen(
                    viewModel = viewModel,
                    onLogout = {
                        isLoggedIn = false
                        showProfile = false
                    },
                    onBack = { showProfile = false }
                )
                else -> HomeScreen(
                    onOpenFriends = { showFriends = true },
                    onOpenProfile = { showProfile = true }
                )
            }

            else -> LoginScreen(onLoginSuccess = { isLoggedIn = true }, startOnRegister = startOnRegister, viewModel = viewModel)
        }
    }
}
